// 客户端错误上报 (P0-1, 2026-08-26 全系统验证最佳实践):
// window.onerror + unhandledrejection → POST /cortex/api/client-log
// 脱敏(去 Bearer token / 卡号 / 邮箱 / 密钥) + 同源去重(5s) + 限流(20/min) + 开发环境跳过。
// 服务端二次脱敏 + 限流 + 落盘; 本模块自身异常全部吞掉, 绝不干扰业务。

const ENDPOINT = '/cortex/api/client-log';
const DEDUP_MS = 5000;
const MAX_PER_MINUTE = 20;

const SANITIZE_PATTERNS = [
  [/(Bearer\s+)[A-Za-z0-9._~+/=-]{8,}/gi, '$1[REDACTED]'],
  [/(token[=:]\s*)[A-Za-z0-9._~+/=-]{8,}/gi, '$1[REDACTED]'],
  [/\b(sk-[A-Za-z0-9_-]{8,})\b/g, '[REDACTED_KEY]'],
  [/\b[0-9]{13,19}\b/g, '[REDACTED_CARD]'],
  [/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, '[REDACTED_EMAIL]'],
];

export function sanitize(text) {
  let s = String(text || '').slice(0, 8000);
  for (const [re, rep] of SANITIZE_PATTERNS) s = s.replace(re, rep);
  return s;
}

let lastKey = '';
let lastTs = 0;
let sentThisMinute = 0;
let minuteStart = 0;

function send(entry) {
  const now = Date.now();
  if (now - minuteStart > 60000) { minuteStart = now; sentThisMinute = 0; }
  if (sentThisMinute >= MAX_PER_MINUTE) return;
  const key = entry.message + '|' + (entry.source || '');
  if (key === lastKey && now - lastTs < DEDUP_MS) return;
  lastKey = key; lastTs = now; sentThisMinute++;
  try {
    // keepalive: 页面跳转/关闭时也能送达
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(entry),
      keepalive: true,
    }).catch(() => {});
  } catch (_) { /* 上报失败绝不影响业务 */ }
}

function baseEntry(source, message, stack) {
  return {
    ts: new Date().toISOString(),
    message: sanitize(message).slice(0, 2000),
    source: sanitize(source || '').slice(0, 2000),
    stack: sanitize(stack || '').slice(0, 8000),
    url: sanitize(window.location.href).slice(0, 2000),
    ua: sanitize(navigator.userAgent || '').slice(0, 500),
  };
}

export function initErrorReporter() {
  if (import.meta.env.DEV) return; // 开发模式不上报
  if (window.__ozErrorReporterInit) return;
  window.__ozErrorReporterInit = true;

  window.addEventListener('error', (e) => {
    const msg = (e && e.message) || 'Unknown error';
    send(baseEntry(e && e.filename, msg, e && e.error && e.error.stack));
  });

  window.addEventListener('unhandledrejection', (e) => {
    const r = e && e.reason;
    const msg = (r && (r.message || r.reason)) || String(r);
    send(baseEntry('unhandledrejection', msg, r && r.stack));
  });
}
